import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import withMemo from '../../decorators/withMemo';
import LayoutDefault from '../../components/LayoutDefault';
import Header from '../../components/Header';
import Feedback from '../../components/Feedback';
import Footer from '../../components/Footer';
var ErrorTemplate = function ErrorTemplate(_ref) {
  var layoutProps = _ref.layoutProps,
    headerProps = _ref.headerProps,
    feedbackProps = _ref.feedbackProps,
    footerProps = _ref.footerProps;
  return /*#__PURE__*/React.createElement(LayoutDefault, _extends({}, layoutProps, {
    header: /*#__PURE__*/React.createElement(Header, headerProps),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Feedback, feedbackProps)),
    footer: /*#__PURE__*/React.createElement(Footer, footerProps)
  }));
};
ErrorTemplate.propTypes = {
  layoutProps: PropTypes.any,
  headerProps: PropTypes.any,
  feedbackProps: PropTypes.any,
  footerProps: PropTypes.any
};
ErrorTemplate.defaultProps = {
  layoutProps: null,
  headerProps: null,
  feedbackProps: null,
  footerProps: null
};
export default withMemo()(ErrorTemplate);